<template>
    <div class="bg-grey-lighter flex justify-center items-center clearfix p-2 rounded">
        <feather-icon class="cursor-pointer absolute border-none z-10 mr-2" :icon="icon"></feather-icon>
        <select  class="w-full custom-select" v-model="selected" @change="() => $emit('input', selected)" :props="$props.selectProps" :disabled="disabled" :color="color" :multiple="multiple" >
           <slot name="item"></slot>
        </select>
    </div>
</template>

<script>
export default {
    

    props:{
        value: String|Number|Array|Object,
        selectProps: Object,
        icon:String,
        multiple: Boolean,
        color: 'String',
        disabled: Boolean
    },

    data () {
        return {
            selected: null
        }
    },

    created () {
        this.selected = this.value;
    }
}
</script>

<style scoped>
    .custom-select{
        border-style:none;
        background-color:#F1F5F8;
    }
</style>
